module.exports = __webpack_public_path__ + "static/media/Amelia_Island_FL_History_Museum_beach_diorama.96c52598.webp";